'use client';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './Divider.module.scss.mjs';

const cx = classNames.bind(styles);
function Divider() {
  return /*#__PURE__*/React.createElement("span", {
    className: cx('article')
  });
}

export { Divider as default };
